export function applyUIStateTransitions(scene, { dt, keys, player }) {
  const p = player || scene.playerEntity;
  if (!p) return false;
  const respawnPressed = !!keys.r && !scene.prevRespawnKeyDown;
  scene.prevRespawnKeyDown = !!keys.r;

  scene.netInputFlags = {
    left: keys.left,
    right: keys.right,
    up: keys.up,
    down: keys.down,
    jump: keys.space,
    dash: keys.f,
    slash: keys.d,
    throw: keys.a,
    kick: keys.s,
    respawn: respawnPressed,
  };

  // Death
  scene.ui?.setInteractTextVisible(false);
  if (p.dead) {
    if (respawnPressed) {
      p.reset();
      scene.anim.current = "Idle";
      scene.anim.prev = "";
      scene.anim.blinkTimer = 0;
      scene.playerSprite.clearTint();
      scene.playerSprite.setAlpha(1);
      scene.ui?.hideDeathScreen?.();
    }
    return true;
  }

  // Dying
  if (p.dying) {
    p.updateTimers(dt);
    if (p.dead) scene.ui?.showDeathScreen?.();
    return true;
  }

  p.updateTimers(dt);

  // Hit-stop: freeze player physics and animation
  if (p.hitStopTimer > 0) {
    if (!scene.playerSprite.anims.isPaused) scene.playerSprite.anims.pause();
    for (const entity of scene.entities) {
      if (entity === p) continue;
      entity.update(dt);
    }
    scene.entities = scene.entities.filter((e) => e === p || !e.markedForRemoval);
    for (const item of scene.items) item.update(dt);
    scene.items = scene.items.filter((i) => !i.markedForRemoval);
    scene.effects = scene.effects.filter((e) => !e.markedForRemoval);
    return true;
  }

  if (scene.playerSprite.anims.isPaused) scene.playerSprite.anims.resume();

  return false;
}
